import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { puoAccedere } from '../../utils/permessi';

// Avviso mostrato nei moduli di una scheda collegata all'anagrafica: i dati comuni (nome, codice fiscale, partita IVA, tipo di soggetto,
// codice azienda) sono in sola lettura e si modificano in Anagrafiche. Il link c'è solo per chi ha almeno la lettura su Anagrafiche.
export default function AvvisoDatiComuni({ anagraficaId, onNavigare, elenco = 'nome, codice fiscale, partita IVA, tipo di soggetto e codice azienda' }) {
  const { utente } = useAuth();
  const vede = puoAccedere(utente, 'anagrafiche');
  return (
    <div role="note" style={{ background: '#F7F7EA', border: '1px solid #D3D678', borderRadius: '8px', padding: '0.6rem 0.8rem', marginBottom: '0.9rem', fontSize: '0.84rem', lineHeight: 1.4 }}>
      I dati comuni dell'azienda ({elenco}) sono in <strong>Anagrafiche</strong> e qui sono in sola lettura.{' '}
      {vede
        ? <Link to={`/anagrafiche/${anagraficaId}`} onClick={onNavigare}>Modifica in Anagrafiche</Link>
        : <span style={{ color: '#555' }}>Per modificarli rivolgiti a chi gestisce le anagrafiche.</span>}
    </div>
  );
}
